module.exports = require('./assign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/object/extend.js
 ** module id = 354
 ** module chunks = 0
 **/